<template>
    <section class="module-small bg-dark galleryBackground">
          <div class="container">
            <div class="row intro-wrap" style="padding-bottom: 5%;">
              <div class="col-sm-offset-4 col-sm-4 story-title">
                <img v-lazy="imgUrl1" alt="dwerve">
              </div>
            </div>
            <div class="row" style="margin-bottom: 40px">
                <div class="col-sm-offset-1 col-sm-8 col-xs-8 cta-title-s">
                   <span class="emphasized">Trolls have ransacked your village...</span><br/> during the day without turning to stone!
                </div>
                <div class="col-sm-2 col-xs-4">
                    <img v-lazy="imgUrl2" alt="dwerve" width=164 class="story-image troll">
                </div>
            </div>
            <div class="row" style="margin-bottom: 40px">
                <div class="col-sm-offset-1 col-xs-4 col-sm-2" >
                    <img v-lazy="imgUrl3" alt="dwerve" width=146 class="story-image slice">
                </div>
                <div class="col-sm-8 col-xs-8 cta-title-s middle" >
                   <span class="emphasized ">Armed with turrets and traps,</span> <br/> you adventure into dungeons crawling with dwarf-thirsty fiends to hack ‘em to pieces and burn ‘em to ash.
                </div>
            </div>
            <div class="row" >
                <div class="col-sm-offset-1 col-sm-8 col-xs-8 cta-title-s">
                    Do you have the nuts (and bolts) to explore deep enough to <span class="emphasized">destroy their secret weapon?</span>
                </div>
                <div class="col-sm-2 col-xs-4">
                    <img v-lazy="imgUrl4"  alt="dwerve" width=82 class="story-image lever">
                </div>
            </div>
            <!-- <hr class="style-seven1" /> -->
            <div style="text-align: center;">
              <img class="turrets" v-lazy="imgUrl5" alt="dwerve"/>
            </div>
          </div>
        </section>
</template>

<script>
export default {
  data () {
    return {
      imgUrl1: '/static/assets/images/Story3.png',
      imgUrl2: '/static/assets/images/Troll-Grunt.gif',
      imgUrl3: '/static/assets/images/Slice-Tower.gif',
      imgUrl4: '/static/assets/images/Lever.gif',
      imgUrl5: '/static/assets/images/all-turrets-transparent2.gif',
    }
  }
}
</script>


<style scoped>
.story-image {
  max-width: unset;
  display: block;
  margin: 0 auto;
}
img.story-image.troll {
    margin-left: -90px;
}
img.story-image.slice {
    margin-left: 60px;
}
img.story-image.lever {
    margin-left: -30px;
}

@media only screen and (max-device-width: 580px) {
  img.story-image.troll {
    margin-left: -40px !IMPORTANT;
}
img.story-image.slice {
    margin-left: 25px !IMPORTANT;
}
img.story-image.lever {
    margin-left: 0 !important;
}
}
.story-text {
  text-align: center;
  font-size: 60px;
  color: #121519;
  font-family: Digitalt;
}
.story-title {
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  background-size: contain;
}
.col-xs-4,
.col-xs-2 {
  padding-left: 0;
}
.turrets {
  left: 30%;
  top: 35%;
  padding-top: 45px;
  padding-bottom: 13px;
  position: inherit;
}
@media only screen and (max-device-width: 480px) {
  .turrets {
    position: inherit;
  }
}

.galleryBackground {
  background: url(/static/assets/images/Dwerve-Brick-Texture.png);
}
@font-face {
  font-family: Digitalt;
  font-display: swap;
  src: url(/static/assets/lib/Digitalt.otf);
}
/* .cta-title-s {
  font-family: Digitalt;
  font-size: 30px;
  color: #ffb03d;
  background: linear-gradient(
    to right,
    rgb(255, 181, 63) 0%,
    rgb(255, 255, 255) 15%,
    rgb(255, 255, 255) 29%,
    rgb(255, 255, 255) 75%,
    rgb(255, 255, 255) 77%,
    rgb(255, 177, 61) 100%
  );
} */

.cta-title-s {
  font-family: Grandmaster;
  font-size: 22px;
  color: #fff;
  text-align: left;
  text-shadow: -2.4px -2.4px 0 #282e35, -2.4px -1.4px 0 #282e35,
    -2.4px -0.4px 0 #282e35, -2.4px 0.6px 0 #282e35, -2.4px 1.6px 0 #1d1a44,
    -2.4px 2.6px 0 #282e35, -1.4px -2.4px 0 #282e35, -1.4px -1.4px 0 #282e35,
    -1.4px -0.4px 0 #282e35, -1.4px 0.6px 0 #282e35, -1.4px 1.6px 0 #282e35,
    -1.4px 2.6px 0 #282e35, -0.4px -2.4px 0 #282e35, -0.4px -1.4px 0 #282e35,
    -0.4px -0.4px 0 #282e35, -0.4px 0.6px 0 #282e35, -0.4px 1.6px 0 #282e35,
    -0.4px 2.6px 0 #282e35, 0.6px -2.4px 0 #282e35, 0.6px -1.4px 0 #282e35,
    0.6px -0.4px 0 #282e35, 0.6px 0.6px 0 #282e35, 0.6px 1.6px 0 #282e35,
    0.6px 2.6px 0 #282e35, 1.6px -2.4px 0 #282e35, 1.6px -1.4px 0 #282e35,
    1.6px -0.4px 0 #282e35, 1.6px 0.6px 0 #282e35, 1.6px 1.6px 0 #282e35,
    1.6px 2.6px 0 #282e35, 2.6px -2.4px 0 #282e35, 2.6px -1.4px 0 #282e35,
    2.6px -0.4px 0 #282e35, 2.6px 0.6px 0 #282e35, 2.6px 1.6px 0 #282e35,
    2.6px 2.6px 0 #282e35;
}
hr.style-seven {
  height: 7px;
  border: 18px dashed #999999a3;
  margin-bottom: 55px;
}
.hr-pattern {
  margin-top: 55px;
  margin-bottom: 48px;
  height: 7px;
  border: 18px dashed #999999a3;
}
.emphasized {
  text-transform: uppercase;
  animation-duration: 6s;
  -vendor-animation-duration: 6s;
}
.cta-title-s.middle {
    padding-left: 75px;
}
.emphasized {
  font-size: 24px;
  color: #33adff;
  position: relative;
  text-shadow: -2.4px -2.4px 0 #1d1a44, -2.4px -1.4px 0 #1d1a44,
    -2.4px -0.4px 0 #1d1a44, -2.4px 0.6px 0 #1d1a44, -2.4px 1.6px 0 #1d1a44,
    -2.4px 2.6px 0 #1d1a44, -1.4px -2.4px 0 #1d1a44, -1.4px -1.4px 0 #1d1a44,
    -1.4px -0.4px 0 #1d1a44, -1.4px 0.6px 0 #1d1a44, -1.4px 1.6px 0 #1d1a44,
    -1.4px 2.6px 0 #1d1a44, -0.4px -2.4px 0 #1d1a44, -0.4px -1.4px 0 #1d1a44,
    -0.4px -0.4px 0 #1d1a44, -0.4px 0.6px 0 #1d1a44, -0.4px 1.6px 0 #1d1a44,
    -0.4px 2.6px 0 #1d1a44, 0.6px -2.4px 0 #1d1a44, 0.6px -1.4px 0 #1d1a44,
    0.6px -0.4px 0 #1d1a44, 0.6px 0.6px 0 #1d1a44, 0.6px 1.6px 0 #1d1a44,
    0.6px 2.6px 0 #1d1a44, 1.6px -2.4px 0 #1d1a44, 1.6px -1.4px 0 #1d1a44,
    1.6px -0.4px 0 #1d1a44, 1.6px 0.6px 0 #1d1a44, 1.6px 1.6px 0 #1d1a44,
    1.6px 2.6px 0 #1d1a44, 2.6px -2.4px 0 #1d1a44, 2.6px -1.4px 0 #1d1a44,
    2.6px -0.4px 0 #1d1a44, 2.6px 0.6px 0 #1d1a44, 2.6px 1.6px 0 #1d1a44,
    2.6px 2.6px 0 #1d1a44;
}
@media only screen and (max-width: 450px) {
  .cta-title-s {
    font-size: 15px;
  }
  .emphasized {
    font-size: 15px;
  }
  .row.intro-wrap {
    margin-bottom: 30px;
}
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .emphasized {
    font-size: 21px;
  }
  .cta-title-s {
    font-size: 19px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Home/Intro.vue